// LoginPage.js
import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate hook

import "./animate.css";
import "./WOW-style.css";
import "./media.css";
import { loginRequest } from "../../authConfig";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";

const LoginPage = () => {
  const [greeting, setGreeting] = useState("Good Morning");
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    username: "",
    password: "",
  });

  const [valid, setValid] = useState(true);
  const { showLoader, hideLoader } = useContext(LoaderContext);

  const navigate = useNavigate(); // Initialize useNavigate hook
  const { instance, accounts } = useMsal();
  // const apiUrl = process.env.REACT_APP_Login_PATH;
  const prod = {
    url: process.env.REACT_APP_Login_PATH,
  };
  const dev = {
    url: "",
  };

  const { url } = process.env.NODE_ENV === "development" ? dev : prod;
  //console.log(url);
  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!instance) {
          throw new Error("MSAL instance is not available");
        }
        await instance.initialize();

        // Handle the redirect response
        const tokenResponse = await instance.handleRedirectPromise();
       // console.log("tokenResponse=", tokenResponse);

        if (tokenResponse) {
        } else {
          const currentAccounts = instance.getAllAccounts();

          if (currentAccounts.length === 0) {
            // No accounts available, initiate login redirect
            // await instance.loginRedirect(loginRequest);
            await handleLogin();
          } else {
            try {
              // Try acquiring token silently
              const silentResponse = await instance.acquireTokenSilent({
                ...loginRequest,
                account: currentAccounts[0], // Ensure the correct account is used
              });
             // console.log("Silent token response", silentResponse);
            } catch (error) {
              if (error instanceof InteractionRequiredAuthError) {
                await handleLogin();
                // Fallback to redirect if silent acquisition fails
                // await instance.acquireTokenRedirect(loginRequest);
              } else {
                // Handle other errors
                await instance.loginRedirect(loginRequest);
                console.error("Error acquiring token silently:", error);
              }
            }
          }
        }
      } catch (err) {
        console.error("Error during token acquisition:", err);
      } finally {
      }
    };

    const fetchDataFromApi = async () => {
      const payload = {
        UserName: accounts[0]?.username.toLowerCase(),
        microsoftAD: true,
      };
     // console.log(payload);
     // console.log(url);
      //const response = await axios.post('/Login/Login', payload);
      const response = await axios.post(`${url}/Login/Login`, payload);
      try {
        // Handle successful response
        if (response?.data?.message == "Authentication Failed") {
          // handleLogin();
         // console.log("Authentication Failed");

          await instance.logout();
          // await instance.loginRedirect(loginRequest);
        } else {
          if (response.data) {
           // console.log("responseData", response.data);
            if (response.data.firstLogin === true) {
              ChangePassword(response.data.uid);
            } else {
              // Check if user has the required cookie
              const hasCookie = document.cookie
                .split(";")
                .some((item) => item.trim().startsWith("ApplicationToken"));

              if (response.data.data.roles.length > 0) {
                if (hasCookie) {
                 // console.log("hasCookie");
                  // Redirect to calendar
                  window.location.href = `/WOW_API/calendar`;

                  // window.location.href = `${url}/calendar`;
                } else {
                  // Handle case when cookie is not present
                  console.log("Required cookie not found.");
                }
              }
            }
          }
        }
      } catch (e: any) {}
    };

    fetchToken();
    fetchDataFromApi();
  }, [instance, accounts]);

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (e) {
      console.error("Login failed:", e);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Reset errors
    setErrors({
      username: "",
      password: "",
    });
    setValid(true);

    // Validate inputs
    if (!username) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        username:
          "Sorry, we don't recognize this email address. <br /> Please try again.",
      }));
      setValid(false);
    }

    if (!password) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password:
          "Sorry, we don't recognize this password. <br /> Please try again.",
      }));
      setValid(false);
    }

    if (!valid) {
      return; // Stop execution if validation fails
    }

    try {
      // Send login request
      const response = await axios.post(`${url}//Login/Login`, {
        username,
        password,
      });
     // console.log("Response Normal", response);

      // Handle successful response
      if (response.data) {
       // console.log("responseData", response.data.data.roles);
        debugger;
        if (response.data.data.firstLogin === true) {
          navigate(`/resetPassword/${response.data.data.uid}`);
        } else {
          // Check if user has the required cookie
          const hasCookie = document.cookie
            .split(";")
            .some((item) => item.trim().startsWith("ApplicationToken"));

          if (response.data.data.roles.length > 0) {
            if (hasCookie) {
             // console.log("hasCookie");
              // Redirect to calendar
              window.location.href = `${url}/calendar`;
              //   window.location.href = `/WOW_API/calendar`;
            } else {
              // Handle case when cookie is not present
              console.log("Required cookie not found.");
            }
          }
        }
      }
    } catch (error) {
      console.error("Login failed:", error);
      // Handle login error
      setErrors((prevErrors) => ({
        ...prevErrors,
        username: "Sorry, we encountered an error. Please try again.",
        password: "Sorry, we encountered an error. Please try again.",
      }));
    }
  };

  const ChangePassword = (data: any) => {};

  return (
    <div className="login_bg">
      <section className="login_section">
        <div className="container">
          <div className="row justify-content-center  col-lg-12">
            {showLoader}
            {/* <div className="col-lg-5 center_mode">
              <div className="lhs_grid wow animate__animated animate__fadeInLeft">
                <h3>
                  Hello ! <br /> <span>{greeting}</span>
                </h3>
                <h4>
                  <span>Login</span> your account
                </h4>
                <form id="loginform">
                  <div className="form-group">
                    <label>
                      <img src="images/icons/007-email.png" alt="email" />
                    </label>
                    <input
                      id="lgn-usrnm"
                      type="text"
                      name="username"
                      value={username}
                      onChange={(e: any) => setUserName(e.target.value)}
                      className="form-control"
                      placeholder="Enter your email address"
                    />
                  </div>
                  <div className="form-group">
                    <label>
                      <img src="images/icons/006-key.png" alt="key" />
                    </label>
                    <input
                      id="lgn-pwd"
                      type="password"
                      name="password"
                      value={password}
                      onChange={(e: any) => setPassword(e.target.value)}
                      className="form-control"
                      placeholder="Enter your password"
                    />
                  </div>
                  <div className="row justify-content-center"></div>
                  {errors.username ? errors.username : ""}
                  {errors.password ? errors.password : ""}
                  <div className="fpass clearfix mb-4">
                    <Link to="/forgetPassword">Forgot password?</Link>
                  </div>
                  <div className="text-center">
                    <button
                      id="lgn-sbmt"
                      type="submit"
                      className="btn_login"
                      onClick={handleSubmit}
                    >
                      <img src="images/icons/008-enter.png" alt="enter" /> Log
                      In
                    </button>
                  </div>
                </form>
                <div className="apps_grid text-center mobile_apps_grid">
                  <p>Available on:</p>
                  <a href="https://play.google.com/store/apps/details?id=com.prosares.wow_mobile">
                    <img
                      className="android-img"
                      src="images/google-play-badge-en.png"
                      alt="Google Play"
                    />
                  </a>
                  <a href="https://apps.apple.com/us/app/prosares-wow/id1644326812">
                    <img
                      className="apple-img"
                      src="images/app_Store.png"
                      alt="App Store"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="rhs_grid wow animate__animated animate__fadeInRight">
                <div className="top_head text-center">
                  <img src="images/logo.png" alt="logo" className="pro-logo" />
                  <h3>
                    Welcome to <br /> <span>WOW Portal</span>
                  </h3>
                  <div className="apps_grid desktop_apps_grid">
                    <p>Available on:</p>
                    <a href="https://play.google.com/store/apps/details?id=com.prosares.wow_mobile">
                      <img
                        className="android-img"
                        src="images/google-play-badge-en.png"
                        alt="Google Play"
                      />
                    </a>
                    <a href="https://apps.apple.com/us/app/prosares-wow/id1644326812">
                      <img
                        className="apple-img"
                        src="images/app_Store.png"
                        alt="App Store"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <div className="chat-windows"></div>

      {/* Email Verification Link Message Modal */}
      {/* <div
        className="modal fade"
        id="login-modal-popup"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="myModalLabel">
                <p>
                  Your details are saved. Kindly check your email for
                  verification Link
                </p>
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
      </div> */}

      {/* Report Correct Number Modal */}
      {/* <div
        className="modal fade"
        id="report-correct-number"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="report-correct-number-title"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <p>Report Correct Number</p>
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="rcn-form">
                <p className="rcn-info-text">
                  Kindly enter the correct number. The concerned person will
                  send you a fresh invite after updating the phone number
                </p>
                <div className="row mt-3">
                  <div className="col-md-3 pr-0">
                    <select
                      id="rcn-drpCountryCode"
                      className="form-control"
                    ></select>
                  </div>
                  <div className="col-md-9">
                    <input
                      id="rcn-txtMobileNo"
                      type="text"
                      name="mobile"
                      placeholder="Enter Your Mobile Number"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button id="rcn-sbmt" type="button" className="btn btn-primary">
                Submit
              </button>
              <button
                id="rcn-cncl"
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default LoginPage;
